module.exports = __webpack_public_path__ + "img/ck.b59648ef.jpg";